let mapsPromise = null

export function loadGoogleMaps() {
  // Already loaded
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve(window.google)
  }

  // Already loading
  if (mapsPromise) {
    return mapsPromise
  }

  mapsPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GMAPS_KEY}&libraries=places`

    script.async = true
    script.defer = true

    script.onload = () => {
      resolve(window.google)
    }

    script.onerror = () => {
      reject(new Error('Failed to load Google Maps API'))
    }

    document.head.appendChild(script)
  })

  return mapsPromise
}
